import { logger, setMetadata } from '@sheerid/jslib';
import { REQUIRED_QUERY_PARAMS, RETURN_TO_LANDING_REDIRECT } from '../../constants';


export const redirect = (redirectDestination: string) => {
    const win = window.open(redirectDestination, '_parent') as Window;
    win.focus();
};

export const getQueryParamsByName = (queryParamName: string) => {
    const urlParams = new URLSearchParams(window.location.search);
    const queryParam = urlParams.get(queryParamName);

    if (queryParam) {
        return queryParam;
    }
    return '';
};

export const getQueryParamsFromUrl = (url?: string) => {
    const newUrl = new URL(url || window.location.toString());
    return new URLSearchParams(newUrl.search.slice(1));
};

export const sendPostMessage = (message: any, url?: string) => {
    try {
        window.parent.postMessage(message, url || '*');
        logger.info(`postMessage sent to ${url || '*'} with message:`, message);
    } catch (e) {
        logger.error('postMessage failed to send', e as string);
    }
};


export const isQueryStringValid = () => {
    let isValid = true;

    REQUIRED_QUERY_PARAMS.forEach((queryParam: string) => {
        if (!getQueryParamsByName(queryParam)) {
            isValid = false;
        }
    });
    return isValid;
};

export const createValidRedirect = (redirectBase: string) => {
    let baseUrl: URL;
    try {
        baseUrl = new URL(redirectBase);
    } catch {
        baseUrl = new URL(RETURN_TO_LANDING_REDIRECT);
    }
    return baseUrl.href;
};

export const addMetadataFromQueryString = () => {
    const endUserId = getQueryParamsByName('euid') || '';
    const oid = getQueryParamsByName('oid') || '';
    const ytpid = getQueryParamsByName('ytpid') || '';
    const successRedirectBase = getQueryParamsByName('yrsp') || '';
    const uploadRedirectBase = getQueryParamsByName('yrdup') || '';
    const reverification = getQueryParamsByName('reverification') ? '1' : '';
    const ytsku = getQueryParamsByName('ytsku') || '';

    setMetadata({
        endUserId,
        oid,
        ytpid,
        successRedirect: createValidRedirect(successRedirectBase),
        uploadRedirect: createValidRedirect(uploadRedirectBase),
        reverification,
        ytsku,
    });
};
